import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { db, auth } from '../../integrations/firebase';
import { describePhone } from './phoneHealth';

// The browser's clock is not the server's. Beats are SERVER timestamps, so
// staleness is judged on server time (RTDB tells us the offset) — otherwise a
// PC whose clock runs two minutes fast would call every phone offline.
let offsetMs = 0;
let offsetWatching = false;
export function serverNow() { return Date.now() + offsetMs; }
function watchOffset() {
    if (offsetWatching) return;
    offsetWatching = true;
    try { onValue(ref(db, '.info/serverTimeOffset'), s => { offsetMs = Number(s.val()) || 0; }); } catch { /* best effort */ }
}

/**
 * Live view of one agent's phone (default: the signed-in user). Re-evaluates
 * every 5 s so "offline" appears on time even when nothing is written — a dead
 * phone, by definition, writes nothing.
 */
export function usePhonePresence(uid) {
    const me = uid || auth.currentUser?.uid || '';
    const [pres, setPres] = useState(undefined);   // undefined = loading, null = none
    const [, setTick] = useState(0);
    useEffect(() => {
        if (!me) return undefined;
        watchOffset();
        const unsub = onValue(ref(db, `callappPresence/${me}`), s => setPres(s.val() || null), () => setPres(null));
        const t = setInterval(() => setTick(x => x + 1), 5000);
        return () => { unsub(); clearInterval(t); };
    }, [me]);
    if (pres === undefined) return { loading: true, presence: undefined, view: null };
    return { loading: false, presence: pres, view: describePhone(pres, serverNow()) };
}

export default usePhonePresence;
